// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLensVisualization_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 2L12 6L15 2H9ZM7.9524 10.4991C6.81634 11.385 6.13426 12.4055 5.96171 13.0109L5.89355 13.2501C6.7641 11.9343 9.01476 11 12 11C14.9852 11 17.2359 11.9343 18.1064 13.2501L18.0383 13.0109C17.8657 12.4055 17.1837 11.385 16.0476 10.4991C14.9372 9.63329 13.5225 9 12 9C10.4775 9 9.06285 9.63329 7.9524 10.4991ZM18.2943 13.5852L18.7455 13.7039C20.1995 14.0865 22.2824 15.1046 24 17.012V14.2566C22.5532 13.0734 21.029 12.324 19.7619 11.918C19.3122 10.9047 18.4095 9.80469 17.2774 8.92192C15.9128 7.85794 14.0775 7 12 7C9.92251 7 8.08715 7.85794 6.7226 8.92192C5.59045 9.80469 4.68782 10.9047 4.23806 11.918C2.97099 12.324 1.4468 13.0734 0 14.2566V17.012C1.71764 15.1046 3.80049 14.0865 5.25449 13.7039L5.70571 13.5852C5.57062 13.8768 5.5 14.1835 5.5 14.5C5.5 16.433 8.13401 18 12 18C15.866 18 18.5 16.433 18.5 14.5C18.5 14.1835 18.4294 13.8768 18.2943 13.5852ZM16.5 14.5C16.5002 14.5077 16.5014 14.5622 16.4157 14.6789C16.3169 14.8136 16.1106 15.0146 15.7296 15.226C14.9588 15.6535 13.6898 16 12 16C10.3102 16 9.04125 15.6535 8.27045 15.226C7.88941 15.0146 7.68313 14.8136 7.58428 14.6789C7.49856 14.5622 7.49981 14.5083 7.49999 14.5006V14.4994C7.49981 14.4917 7.49856 14.4378 7.58428 14.3211C7.68313 14.1864 7.88941 13.9854 8.27045 13.774C9.04125 13.3465 10.3102 13 12 13C13.6898 13 14.9588 13.3465 15.7296 13.774C16.1106 13.9854 16.3169 14.1864 16.4157 14.3211C16.5014 14.4378 16.5002 14.4923 16.5 14.5ZM15 23H9L12 19L15 23Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLensVisualization is a generated icon component.
 */
let IconMedLensVisualization = IconMedLensVisualization_1 = class IconMedLensVisualization extends IconBaseElement {
    render() {
        return html `${IconMedLensVisualization_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLensVisualization.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLensVisualization = IconMedLensVisualization_1 = __decorate([
    customElement('zui-icon-med-lens-visualization')
], IconMedLensVisualization);
export { IconMedLensVisualization };
